import { render } from "./SwappedTeams.vue?vue&type=template&id=2460a51a"
import script from "./SwappedTeams.vue?vue&type=script&lang=js"
export * from "./SwappedTeams.vue?vue&type=script&lang=js"

import "./SwappedTeams.vue?vue&type=style&index=0&id=2460a51a&lang=css"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__